import React, { useEffect } from "react";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import FormSelect from "Common/Custom/FormSelect";
import FormDatePicker from "Common/Custom/ReactFlatpickr";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import NotFound from "Common/Custom/NotFound";

import fields from "../json/PurchaseReturnFeilds.json";
import PurchaseReturnItemsTable from "./PurchaseReturnItemsTable";

const PurchaseReturnListForm = ({
  values,
  errors,
  handleChange,
  handleSubmit,
  handleSearch,
  loading,
  supplierOptions,
  invoiceOptions,
  setValues,
}) => {
  const { formdata, tableFields } = fields;

  // auto update grand total
  useEffect(() => {
    const total_amount = (values.items || []).reduce((s, x) => s + Number(x.total || 0), 0);
    if (total_amount !== Number(values.total_amount || 0)) {
      setValues((prev) => ({ ...prev, total_amount }));
    }
  }, [values.items, setValues]);

  const supplierDropdown = supplierOptions.map((s) => ({
    value: s.supplier_id,
    label: s.supplier_name,
  }));

  const invoiceDropdown = invoiceOptions.map((i) => ({
    value: i.purchase_invoice_id,
    label: i.purchase_invoice_id,
  }));

  return (
    <PageBody headerchildren={<HeadingOne>Purchase Return</HeadingOne>} card={false}>
      <div className="card">
        <div className="card-body">
          <div className="row g-3">
            {formdata.map((field) => (
              <FormSelect
                key={field.name}
                field={field}
                value={values[field.name] ?? ""}
                handleChange={handleChange}
                options={field.name === "supplier_id" ? supplierDropdown : invoiceDropdown}
                error={errors[field.name]}
              />
            ))}

            <FormSubmitButton
              label="Search"
              type="button"
              loading={loading}
              colSize="col-md-2 mt-md-5"
              align="start"
              onClick={handleSearch}
            />

            {values.items?.length > 0 ? (
              <>
                <FormDatePicker
                  field={{
                    name: "return_date",
                    label: "Return Date",
                    required: true,
                    fieldSize: "col-md-4",
                  }}
                  value={values.return_date}
                  handleChange={handleChange}
                  error={errors.return_date}
                  dateFormat="Y-m-d"
                />

                <div className="col-12">
                  <PurchaseReturnItemsTable
                    items={values.items}
                    setItems={(items) => setValues((prev) => ({ ...prev, items }))}
                    tableFields={tableFields}
                    returnReason={values.reason}
                    setReturnReason={(reason) =>
                      setValues((prev) => ({ ...prev, reason }))
                    }
                    handleSubmit={handleSubmit}
                    loading={loading}
                  />
                </div>
              </>
            ) : (
              <NotFound
                title="No Data Found"
                text="Try searching with another filter."
                card={false}
              />
            )}
          </div>
        </div>
      </div>
    </PageBody>
  );
};

export default PurchaseReturnListForm;
